export default __webpack_public_path__ + "static/media/earthshatter.fea17f2f.png";